import React from "react";
import PropTypes from "prop-types";

import Checkbox from "components/Checkbox";
import Translate from "utils/translate";

import { ConfirmDialog } from ".";

const { t } = new Translate("SpaceStatusDialog");

class SpaceStatusDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isChecked: true };
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  handleCheckboxChange() {
    this.setState({ isChecked: !this.state.isChecked });
  }

  render() {
    const { onCancel, onConfirm } = this.props;
    const { isChecked } = this.state;

    return (
      <ConfirmDialog
        confirmLabel={t("confirm")}
        onCancel={onCancel}
        onConfirm={() => onConfirm(isChecked)}
      >
        <div>{t("body")}</div>
        <br />
        <Checkbox isChecked={isChecked} label={t("notify")} onChange={this.handleCheckboxChange} />
      </ConfirmDialog>
    );
  }
}

SpaceStatusDialog.propTypes = {
  onCancel: PropTypes.func.isRequired, // eslint-disable-line
  onConfirm: PropTypes.func.isRequired,
};

export default SpaceStatusDialog;
